<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.table && localService.languageContent.product_config && wrappers">
    <div class="banner center" style="max-width:1000px;">
        <div class="row freeze_height">
            <div class="col-4">
                <ngx-select [items]="expectedBusinessTypes" [optionValueField]="'key'" [optionTextField]="'value'"
                    placeholder="{{localService.languageContent.product_config.business_type}}"
                    [(ngModel)]="businessType" [noAutoComplete]="true" [allowClear]="false"
                    [disabled]="expectedBusinessTypes.length == 1" (select)="onLoad()">
                </ngx-select>
            </div>
            <div class="col-4">
                &nbsp;
            </div>
            <div class="col-4">
                <button type="button" class="btn btn-primary" style="width: 100%;" (click)="onAction(1)" [disabled]="selectedCount == 0">
                    {{localService.languageContent.product_config.convert_to_new_base}}
                    <span>&nbsp;({{selectedCount}})</span>
                </button>
            </div>
        </div>
        <div class="row freeze_height row_header">
            <div class="col-6">
                <label class="adjust_checkbox" style="font-weight: normal;float: left;">
                    <input type="checkbox" [(ngModel)]="isSelectedAll" (change)="onCheckAll()" />
                    <span>&nbsp;</span>
                </label>
                {{localService.languageContent.table.title}}
            </div>
            <div class="col-3">
                {{localService.languageContent.product_config.current_base}}
            </div>
            <div class="col-3">
                {{localService.languageContent.product_config.new_base}}
            </div>
        </div>
        <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
            <div class="row styled_row" *ngFor="let item of wrappers.items"
                [ngClass]="item.isSelected ? 'selected-item': ''">
                <div class="col-6">
                    <label class="adjust_checkbox" style="font-weight: normal;">
                        <input type="checkbox" [(ngModel)]="item.isSelected" (change)="onSelect()" />
                        <span>{{item.v4}}</span>
                    </label>
                    <span>&nbsp;-&nbsp;</span>
                    <span [ngClass]="localService.getLanguageCode(item.v2)">{{item.v1}}</span>
                </div>
                <div class="col-3 right">
                    <span class="en">{{item.v11}}</span>
                </div>
                <div class="col-3 right">
                    <span class="en">{{item.v12}}</span>
                </div>
            </div>
        </div>
    </div>
    <app-paging *ngIf="wrappers && wrappers.paging" [paging]="wrappers.paging"
        (onPagingRefreshed)="onLoad()"></app-paging>
</div>